import React from 'react'
import { Link } from "react-router-dom";
import { Menu } from 'react-feather'
import './dropdown.css';
import { LanguageDropdown } from './header-language-dropdown';
import { HeaderMenu } from './header-menu';
import { NavItem } from './header-nav-item';
import { AuthButton } from './header-auth-button';
import auth from '../utils/auth';
import { useScrollPosition, /* useViewport, viewportBreakpoint */ } from '../utils';

const routes = [
  {
    path: '/about',
    label: {
      en: 'About Us',
      id: 'Tentang'
    }
  },
  {
    path: '/region-map',
    label: {
      en: 'Map',
      id: 'Peta Penanggulangan'
    }
  },
  {
    path: '/organization',
    label: {
      en: 'Organizations',
      id: 'Organisasi'
    }
  },
  {
    path: '/resource',
    label: {
      en: 'Resources',
      id: 'Produk'
    }
  },
  {
    path: '/event',
    label: {
      en: 'Events',
      id: 'Acara'
    }
  },
  {
    path: '/blog',
    label: {
      en: 'Blog',
      id: 'Blog'
    }
  },
  // {
  //   path: '/contact',
  //   label: {
  //     en: 'Contact Us',
  //     id: 'Kontak'
  //   }
  // },
]


const Header = ({ noDropdown }) => {
  // const { width } = useViewport()
  // const breakpoint = viewportBreakpoint.tablet
  // const isMobile = width < breakpoint
  const [toggled, setToggled] = React.useState(false)
  const [language, setLanguage] = React.useState('en')
  const { getCurrentUser } = auth()

  const currentUser = getCurrentUser() || {}
  const role = currentUser.role

  const openMenu = () => {
    setToggled(true)
  }

  const handleLanguage = (lang) => {
    setLanguage(lang)
  }

  const [hideOnScroll, setHideOnScroll] = React.useState(true)

  useScrollPosition(({ prevPos, currPos }) => {
    if(!toggled){
      const isShow = currPos.y > prevPos.y
      if (isShow !== hideOnScroll) setHideOnScroll(isShow)
    }
  }, [hideOnScroll, toggled])

  return (
    <header>
      <div
        className="fixed top-0 left-0 bg-black w-full flex justify-between items-center"
        style={{
          transition: '0.2s',
          transform: hideOnScroll ? 'translateY(0)' : 'translateY(-100%)',
          zIndex: 800
        }}
      >
        <div className="flex items-center py-4 lg:py-5 px-4 lg:px-6 bg-white">
          <div>
            <Link to="/">
              <img src="/images/ikhub-logo.png" alt="i-KHUB" style={{maxWidth: '140px'}}/>

              {/* {
                isMobile ? (
                  <img src="/images/ikhub-logo-mobile.png" alt="i-KHUB" style={{maxWidth: '93px'}}/>
                  ) : (
                  <img src="/images/ikhub-logo.png" alt="i-KHUB" style={{maxWidth: '341px'}}/>
                )
              } */}

              {/* <h1 className="text-3xl md:text-4xl mr-3 leading-none">i-KHUB</h1> */}
            </Link>
          </div>
          {/* <div style={{maxWidth: '100px', fontSize: '9px'}} className="leading-tight hidden md:block">
            <h6>Pusat Informasi<br/>Penanggulangan Terorisme<br/>dan Ekstremisme Kekerasan</h6>
          </div> */}
        </div>
        <div className="xl:hidden py-5 pr-5">
          <div className="flex items-center">
            <AuthButton small={true} />
            <Menu color="#fff" className="ml-5" onClick={openMenu}/>
            {
              toggled &&
              <HeaderMenu
                setToggled={setToggled}
                role={role}
                routes={routes}
                language={language}
              />
            }
          </div>
        </div>
        <div className="hidden xl:block py-5 px-8">
          <nav className="flex items-center relative">
            {
              routes.map((r, i) => (
                <NavItem key={i}>
                  <Link className="text-white font-accent uppercase" to={r.path}>{r.label[language]}</Link>
                </NavItem>
              ))
            }
            <div className="border-l border-white ml-8">
              <AuthButton small/>
            </div>
            <LanguageDropdown onChange={handleLanguage}/>
          </nav>
        </div>
      </div>
    </header>
  )
}

export { Header }
